import { immerFreeze } from "../globalConsts";

export const TITLE_APPEND = " | FLOWIO";

export const SENTRY_TRACE_SAMPLE_RATE = 0.05;
export const SENTRY_DSN =
  "https://f5bc531f0f184df58125eee9b9d9b1c9@o1230264.ingest.sentry.io/6378717";

export const DEFAULT_COLORS = immerFreeze({
  bgColor: "#F5F7FA",
  primaryColor: "#258DCD",
  secondaryColor: "#414D6B",
});
